/**
 * ChipCloseIcon Component
 *
 * Close/dismiss icon for filter chips.
 * Based on Figma node 10568:73071: 15x15 diagonal cross with rounded stroke
 * caps. Renders a smaller X within the viewBox than CloseIcon, matching the
 * design's padded-plus look.
 */

export function ChipCloseIcon({ className }: { className?: string }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M3.53591 3.53467L10.607 10.6057"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.6052 3.53467L3.53418 10.6057"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
